<template>
    <div class="container-fluid">
        <div class="card card-blue">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title">Goods & Services</h4>
                        <h6 class="card-subtitle">List of Goods/Services available for purchase</h6>
                    </div>
                    <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                            <div class="button-group">
                                <router-link :to="{name: 'addpurchasegoodsservices', params: {expressid: currentOrg.express_id}}" class="btn btn-success waves-effect waves-light">
                                    <i class="fas fa-plus"></i> Add Goods & Services
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <multiselect class="form-control multiselect-sm"
                                     :clear-on-select="false"
                                     :close-on-select="true"
                                     :hide-selected="true"
                                     :internal-search="false"
                                     :options="categories"
                                     @search-change="filterCategory"
                                     placeholder="Search Category"
                                     id="category"
                                     v-model="category">
                            <template slot="singleLabel" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc">
                                        {{ props.option.name }}
                                    </div>
                                </div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <h5>{{ props.option.name }}</h5>
                                </div>
                            </template>
                        </multiselect>
                    </div>

                    <div class="form-group col-md-3">
                        <input type="text" class="form-control"
                               placeholder="Search by Name/Variety/Native Name"
                               v-model="search">
                    </div>

                    <div class="form-group col-3">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">{{currentOrg.currency_symbol}}</span>
                            </div>
                            <input type="number" placeholder="Rate" class="form-control" v-model="rate">
                            <select type="number" v-model="comp" class="form-control input-append" style="max-width: 60px;">
                                <option value="=">=</option>
                                <option value=">">&gt;</option>
                                <option value="<">&lt;</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group col-md-2">
                        <div class="btn-group">
                            <button @click="getGoodsServices(1)" class="btn btn-light btn-outline-success font-weight-bold" type="button">
                                <i class="fa fa-search"/> Go!
                            </button>
                            <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold" type="button">
                                <i class="fa fa-undo"/> Reset
                            </button>
                        </div>
                    </div>

                    <div class="col-1 text-right">
                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" v-if="exporting" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                        <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info"
                                data-toggle="dropdown" title="Operations">
                            <i class="fa fa-grip-vertical"/>
                        </button>
                        <div class="dropdown-menu">
                            <a @click="exportGSAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                <i class="fa fa-file-excel"/> Export
                            </a>
                            <input type="file" id="rateupload" ref="rateupload" class="d-none" @change="handleRateUpload" accept=".xlsx"/>
                            <a class="dropdown-item" id="rateuploadbtn" href="javascript:void(0)" @click="$refs.rateupload.click()">
                                <i class="fa fa-upload"/> Upload Rates
                            </a>
                        </div>
                    </div>
                </div>

                <div class="table-responsive" v-if="goodsServices.length>0">
                    <table class="table no-wrap v-middle">
                        <thead>
                        <tr class="border-0 bg-light">
                            <th class="border-0"><h6>Name</h6></th>
                            <th class="border-0"><h6>Variety</h6></th>
                            <th class="border-0"><h6>Native Name</h6></th>
                            <th class="border-0"><h6>Category</h6></th>
                            <th class="border-0"><h6>Properties</h6></th>
                            <th class="border-0"><h6>Current Rate</h6></th>
                            <th class="border-0 text-center"><h6>Action</h6></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(gs, index) in goodsServices">
                            <td>{{gs.name}}</td>
                            <td>{{gs.variety}}</td>
                            <td>{{gs.native}}</td>
                            <td>
                                <goods-services-category :category="gs.category"/>
                            </td>
                            <td class="pl-0">
                                <ul v-if="gs.goods_services_props.length > 0">
                                    <li v-bind:key="index" v-for="(gsp, index) in gs.goods_services_props">
                                        {{gsp.value}}
                                    </li>
                                </ul>
                                <span v-else>N/A</span>
                            </td>
                            <td v-if="gs.rate.amount">{{gs.rate | money}}/{{gs.unit.symbol}}</td>
                            <td v-if="!gs.rate.amount">{{'N/A' }}</td>
                            <td class="text-center">
                                <router-link :to="{name: 'viewpurchasegoodsservices', params: {goodsservicesid: gs.id}}">
                                    <h6>View & Edit</h6>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <template v-else>
                    <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                    <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                </template>
            </div>
            <div class="card-footer" v-if="goodsServices.length>0">
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <label class="col-form-label p-l-10" for="records">Display</label>
                            <div class="col-auto p-t-5">
                                <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length"
                                        v-model="perPage">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <label class="col-form-label" for="records">Records per page</label>
                        </div>
                    </div>
                    <div class="col-6">
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right mb-0'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import XLSX from "xlsx";
    import Multiselect from "vue-multiselect";
    import GoodsServicesCategory from "./GoodsServicesCategory";
    import categories from "@/data/commodityCatagories";

    // const categories = [
    //     {
    //         "name": "Old",
    //         "value": "OLD"
    //     },
    //     {
    //         "name": "Service",
    //         "value": "SERVICE"
    //     },
    //     {
    //         "name": "Vegetables",
    //         "value": "VEGETABLES"
    //     },
    //     {
    //         "name": "Fruits",
    //         "value": "FRUITS"
    //     },
    //     {
    //         "name": "Dry Fruits",
    //         "value": "DRY_FRUITS"
    //     },
    //     {
    //         "name": "Food Grains",
    //         "value": "FOOD_GRAIN"
    //     },
    //     {
    //         "name": "Pulses",
    //         "value": "PULSES"
    //     },
    //     {
    //         "name": "Processed Items",
    //         "value": "PROCESSED_ITEMS"
    //     },
    //     {
    //         "name": "Spices",
    //         "value": "SPICES"
    //     },
    //     {
    //         "name": "Dairy",
    //         "value": "DAIRY"
    //     },
    //     {
    //         "name": "Edible Oils",
    //         "value": "EDIBLE_OILS"
    //     },
    //     {
    //         "name": "Salt Sugar Jaggery",
    //         "value": "SALT_SUGAR_JAGGERY"
    //     },
    //     {
    //         "name": "Beverages",
    //         "value": "BEVERAGES"
    //     },
    //     {
    //         "name": "Exotic",
    //         "value": "EXOTIC"
    //     },
    //     {
    //         "name": "Non Veg",
    //         "value": "NON_VEG"
    //     }
    // ];

    export default {
        name: "ViewPurchaseGoodsServices",
        components: {Paginate, Multiselect, GoodsServicesCategory},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                categories: [],
                goodsServices: [],
                pageCount: 1,
                total: 0,
                perPage: 10,
                category: null,
                search: null,
                exporting: false,
                comp: '=',
                rate: null
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getGoodsServices(1);
            },
            async getGoodsServices(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/purchases/goodsservices/`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            search: this.search,
                            category: this.category ? this.category.value : undefined,
                            comp: this.rate ? this.comp : undefined,
                            rate: this.rate ? Number(this.rate) : undefined,
                            excludeOld: true
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total         = reply.data.total;
                    this.goodsServices = reply.data.goodsAndServices;
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getGoodsServices(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            async reset() {
                this.search   = null;
                this.rate     = null;
                this.comp     = '=';
                this.category = null;
                await this.getGoodsServices()
            },
            perPageRecordChange() {
                if(this.isFiltered) {
                    this.getGoodsServices(1);
                } else {
                    this.getGoodsServices(1);
                }
            },
            async exportGSAsExcel() {
                try {
                    this.exporting = true;

                    let reply            = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/purchases/goodsservices`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            search: this.search,
                            category: this.category ? this.category.value : undefined,
                            comp: this.rate ? this.comp : undefined,
                            rate: this.rate ? Number(this.rate) : undefined,
                            excludeOld: true
                        }
                    });
                    let data             = reply.data.goodsAndServices;
                    let goodsAndServices = [];
                    data.forEach(d => {
                        goodsAndServices.push({
                            "ID": d.id,
                            "Name": d.name,
                            "Variety": d.variety,
                            "Native Name": d.native,
                            "Description": d.description,
                            "Category": d.category,
                            "Measuring Unit": d.unit.symbol,
                            "Currency": d.rate.currency_symbol,
                            "Rate": d.rate.amount
                        })
                    });

                    let workbook  = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(goodsAndServices);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'GoodsAndServices');
                    XLSX.writeFile(workbook, 'goodsAndServices.xlsx');
                } catch(e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            },
            async handleRateUpload() {
                let file      = this.$refs.rateupload.files[0];
                let reader    = new FileReader();
                reader.onload = async (e) => {
                    try {
                        let data     = new Uint8Array(e.target.result);
                        let workbook = XLSX.read(data, {type: 'array'});
                        let arr      = XLSX.utils.sheet_to_json(workbook.Sheets["GoodsAndServices"]);

                        await this.$http.post(`/express/${this.currentOrg.express_id}/purchases/goodsservices/rates`, arr);
                        this.$toastr('success', 'Rate uploaded', 'Success');
                    } catch(e) {
                        this.$toastr('error', 'Rate upload failed', 'Failure');
                        console.error(e);
                    } finally {
                        await this.$router.go(this.$router.currentRoute)
                    }
                };
                reader.readAsArrayBuffer(file);
            },
            filterCategory(search) {
                this.categories = _.filter(categories, (c) => {
                    return c.name.indexOf(search) != -1;
                });
            }
        }
    }
</script>

<style scoped>

</style>
